import styled from 'styled-components';
import { pxToRem } from '../../utils/convert';
import { spacing, subtitle2 } from '../theme';
import { FolderClosed } from '../icons';
import { HoverCard } from './HoverCard';
import { FOLDER_HEIGHT } from './constants';

export const CardStyled = styled(HoverCard)`
  height: ${pxToRem(FOLDER_HEIGHT)};
`;

export const FolderCardText = styled.span<{ $hasPrefix: boolean }>`
  margin-top: ${pxToRem(14)}; /** calculations based off a default height of 48px from figma */
  margin-bottom: ${pxToRem(14)}; /** calculations based off a default height of 48px from figma */
  margin-left: ${pxToRem(-2)}; /** calculations based off a default height of 48px from figma */

  display: inline-block;
  vertical-align: top;
  text-align: left;
  height: ${pxToRem(20)}; /** calculations based off a default height of 48px from figma */
  width: ${({ $hasPrefix }) => `calc(100% - ${pxToRem(FOLDER_HEIGHT)} * ${$hasPrefix ? 2 : 1})`};
  overflow: hidden;
  ${{ ...subtitle2 }}
`;

export const FolderCardIcon = styled(FolderClosed)<{ height: number }>`
  margin: ${({ height }) => pxToRem(height / 2)};
  display: inline-block;
`;

export const CardContentWrapper = styled.div`
  margin: 0 ${spacing.half};
  display: flex;
`;
